/**
 * Page slug mappings for different locales
 * Maps locale-specific slugs to page identifiers
 */
export const pageSlugMap: Record<string, Record<string, string>> = {
  en: {
    'legal': 'legal',
    'privacy': 'privacy',
    'refund-policy': 'refund-policy',
    'free-mlm-software-demo': 'free-mlm-software-demo',
    'mlm-software-features': 'mlm-software-features',
    'mlm-software-modules': 'mlm-software-modules',
    'mlm-software-plans': 'mlm-software-plans',
    'mlm-software-services': 'mlm-software-services',
    'contact': 'contact',
    'faq': 'faq',
    'testimonials': 'testimonials',
    'changelog': 'changelog',
    'industry-solutions': 'industry-solutions',
    'about': 'about',
    'blog': 'blog',
    'mlm-software-blog': 'blog',
    'pricing': 'pricing',
    'mlm-calculator': 'mlm-calculator',
    'mlm-companies': 'mlm-companies',
    'top-5-mlm-software-platforms-in-usa': 'top-5-mlm-software-platforms-in-usa',
  },
  es: {
    'terminos-legales': 'legal',
    'politica-de-privacidad': 'privacy',
    'politica-de-reembolso': 'refund-policy',
    'demostracion-gratuita-del-software-mlm': 'free-mlm-software-demo',
    'caracteristicas': 'mlm-software-features',
    'modulos-de-software-mlm': 'mlm-software-modules',
    'planes-de-software-mlm': 'mlm-software-plans',
    'servicios-de-software-mlm': 'mlm-software-services',
    'contacto': 'contact',
    'preguntas-frecuentes': 'faq',
    'testimonios': 'testimonials',
    'registro-de-cambios': 'changelog',
    'soluciones-industriales': 'industry-solutions',
    'acerca-de-la-compania': 'about',
    'blogs': 'blog',
    'precios': 'pricing',
    'calculadora-mlm': 'mlm-calculator',
    'mlm-companies': 'mlm-companies',
  },
  fr: {
    'mentions-legales': 'legal',
    'politique-de-confidentialite': 'privacy',
    'politique-de-remboursement': 'refund-policy',
    'demo-gratuite-du-logiciel-mlm': 'free-mlm-software-demo',
    'caracteristiques': 'mlm-software-features',
    'modules': 'mlm-software-modules',
    'forfaits-logiciels-mlm': 'mlm-software-plans',
    'services-logiciel-mlm': 'mlm-software-services',
    'nous-contacter': 'contact',
    'foire-aux-questions': 'faq',
    'temoignages': 'testimonials',
    'journal-des-modifications': 'changelog',
    'solutions-industrielles': 'industry-solutions',
    'a-propos-de-la-societe': 'about',
    'blogs': 'blog',
    'tarifs': 'pricing',
    'calculateur-mlm': 'mlm-calculator',
    'mlm-companies': 'mlm-companies',
  },
  it: {
    'termini-legali': 'legal',
    'politica-sulla-privacy': 'privacy',
    'politica-di-rimborso': 'refund-policy',
    'demo-gratuita-del-software-mlm': 'free-mlm-software-demo',
    'caratteristiche': 'mlm-software-features',
    'moduli-software-mlm': 'mlm-software-modules',
    'piani-software-mlm': 'mlm-software-plans',
    'services': 'mlm-software-services',
    'servizi-software-mlm': 'mlm-software-services',
    'mlm-software-services': 'mlm-software-services',
    'contatto': 'contact',
    'domande-frequenti': 'faq',
    'testimonianze': 'testimonials',
    'registro-delle-modifiche': 'changelog',
    'soluzioni-industriali': 'industry-solutions',
    'circa-la-societa': 'about',
    'blog': 'blog',
    'prezzi': 'pricing',
    'calcolatore-mlm': 'mlm-calculator',
    'mlm-companies': 'mlm-companies',
    'le-migliori-piattaforme-software-da-5-mlm-negli-stati-uniti-2025': 'top-5-mlm-software-platforms-in-usa',
    'e-migliori-piattaforme-software-da-5-mlm-negli-stati-uniti-2025': 'top-5-mlm-software-platforms-in-usa',
  },
  de: {
    'rechtliches': 'legal',
    'datenschutzrichtlinie': 'privacy',
    'rueckerstattungsrichtlinie': 'refund-policy',
    'kostenlose-mlm-software-demo': 'free-mlm-software-demo',
    'merkmale': 'mlm-software-features',
    'mlm-software-module': 'mlm-software-modules',
    'mlm-softwareplaene': 'mlm-software-plans',
    'mlm-software-dienstleistungen': 'mlm-software-services',
    'kontaktiere-uns': 'contact',
    'haeufig-gestellte-fragen': 'faq',
    'referenzen': 'testimonials',
    'aenderungsprotokoll': 'changelog',
    'branchenloesungen': 'industry-solutions',
    'ueber-das-unternehmen': 'about',
    'blogs': 'blog',
    'preise': 'pricing',
    'mlm-rechner': 'mlm-calculator',
    'mlm-companies': 'mlm-companies',
  },
  pt: {
    'termos-legais': 'legal',
    'politica-de-privacidade': 'privacy',
    'politica-de-reembolso': 'refund-policy',
    'recursos-de-software-mlm': 'mlm-software-features',
    'modulos-de-software-mlm': 'mlm-software-modules',
    'planos-de-software-mlm': 'mlm-software-plans',
    'servicos-de-software-mlm': 'mlm-software-services',
    'contato': 'contact',
    'perguntas-frequentes': 'faq',
    'depoimentos': 'testimonials',
    'registro-de-mudancas': 'changelog',
    'solucoes-industriais': 'industry-solutions',
    'sobre-nos': 'about',
    'precos': 'pricing',
    'calculadora-mlm': 'mlm-calculator',
  },
  zh: {
    'fa-lu-tiao-kuan': 'legal',
    'yin-si-zheng-ce': 'privacy',
    'tui-kuan-zheng-ce': 'refund-policy',
    'mlm-ruan-jian-gong-neng': 'mlm-software-features',
    'mlm-ruan-jian-mo-kuai': 'mlm-software-modules',
    'mlm-ruan-jian-ji-hua': 'mlm-software-plans',
    'mlm-ruan-jian-fu-wu': 'mlm-software-services',
    'lian-xi-wo-men': 'contact',
    'chang-jian-wen-ti': 'faq',
    'ke-hu-zheng-yan': 'testimonials',
    'geng-gai-ri-zhi': 'changelog',
    'hang-ye-jie-jue-fang-an': 'industry-solutions',
    'mlm-ji-suan-qi': 'mlm-calculator',
  },
};

/**
 * Reverse mapping: page identifier to locale-specific slugs
 */
export const pageToSlugMap: Record<string, Record<string, string>> = {
  'legal': {
    en: 'legal',
    es: 'terminos-legales',
    fr: 'mentions-legales',
    it: 'termini-legali',
    de: 'rechtliche-hinweise',
    pt: 'termos-legais',
    zh: 'fa-lu-tiao-kuan',
  },
  'privacy': {
    en: 'privacy',
    es: 'politica-de-privacidad',
    fr: 'politique-de-confidentialite',
    it: 'politica-sulla-privacy',
    de: 'datenschutzrichtlinie',
    pt: 'politica-de-privacidade',
    zh: 'yin-si-zheng-ce',
  },
  'privacy-policy': {
    en: 'privacy',
    es: 'politica-de-privacidad',
    fr: 'politique-de-confidentialite',
    it: 'politica-sulla-privacy',
    de: 'datenschutzrichtlinie',
    pt: 'politica-de-privacidade',
    zh: 'yin-si-zheng-ce',
  },
  'refund-policy': {
    en: 'refund-policy',
    es: 'politica-de-reembolso',
    fr: 'politique-de-remboursement',
    it: 'politica-di-rimborso',
    de: 'rueckerstattungsrichtlinie',
    pt: 'politica-de-reembolso',
    zh: 'tui-kuan-zheng-ce',
  },
  'free-mlm-software-demo': {
    en: 'free-mlm-software-demo',
    es: 'demostracion-gratuita-del-software-mlm',
    fr: 'demo-gratuite-du-logiciel-mlm',
    it: 'demo-gratuita-del-software-mlm',
    de: 'kostenlose-mlm-software-demo',
  },
  'mlm-software-features': {
    en: 'mlm-software-features',
    es: 'caracteristicas',
    fr: 'caracteristiques',
    it: 'caratteristiche',
    de: 'merkmale',
    pt: 'recursos-de-software-mlm',
    zh: 'mlm-ruan-jian-gong-neng',
  },
  'mlm-software-modules': {
    en: 'mlm-software-modules',
    es: 'modulos-de-software-mlm',
    fr: 'modules',
    it: 'moduli-software-mlm',
    de: 'mlm-software-module',
    pt: 'modulos-de-software-mlm',
    zh: 'mlm-ruan-jian-mo-kuai',
  },
  'mlm-software-plans': {
    en: 'mlm-software-plans',
    es: 'planes-de-software-mlm',
    fr: 'forfaits-logiciels-mlm',
    it: 'piani-software-mlm',
    de: 'mlm-softwareplaene',
    pt: 'planos-de-software-mlm',
    zh: 'mlm-ruan-jian-ji-hua',
  },
  'mlm-software-services': {
    en: 'mlm-software-services',
    es: 'servicios-de-software-mlm',
    fr: 'services-logiciel-mlm',
    it: 'servizi-software-mlm',
    de: 'mlm-software-dienstleistungen',
    pt: 'servicos-de-software-mlm',
    zh: 'mlm-ruan-jian-fu-wu',
  },
  'contact': {
    en: 'contact',
    es: 'contacto',
    fr: 'nous-contacter',
    it: 'contatto',
    de: 'kontaktiere-uns',
    pt: 'contato',
    zh: 'lian-xi-wo-men',
  },
  'faq': {
    en: 'faq',
    es: 'preguntas-frecuentes',
    fr: 'foire-aux-questions',
    it: 'domande-frequenti',
    de: 'haeufig-gestellte-fragen',
    pt: 'perguntas-frequentes',
    zh: 'chang-jian-wen-ti',
  },
  'testimonials': {
    en: 'testimonials',
    es: 'testimonios',
    fr: 'temoignages',
    it: 'testimonianze',
    de: 'referenzen',
    pt: 'depoimentos',
    zh: 'ke-hu-zheng-yan',
  },
  'changelog': {
    en: 'changelog',
    es: 'registro-de-cambios',
    fr: 'journal-des-modifications',
    it: 'registro-delle-modifiche',
    de: 'aenderungsprotokoll',
    pt: 'registro-de-mudancas',
    zh: 'geng-gai-ri-zhi',
  },
  'industry-solutions': {
    en: 'industry-solutions',
    es: 'soluciones-industriales',
    fr: 'solutions-industrielles',
    it: 'soluzioni-industriali',
    de: 'branchenloesungen',
    pt: 'solucoes-industriais',
    zh: 'hang-ye-jie-jue-fang-an',
  },
  'about': {
    en: 'about',
    es: 'acerca-de-la-compania',
    fr: 'a-propos-de-la-societe',
    it: 'circa-la-societa',
    de: 'ueber-das-unternehmen',
    pt: 'sobre-nos',
    zh: 'guan-yu-wo-men',
  },
  'blog': {
    en: 'blog',
    es: 'blogs',
    fr: 'blogs',
    it: 'blog',
    de: 'blogs',
    pt: 'blog',
    zh: 'blog',
  },
  'mlm-software-blog': {
    en: 'mlm-software-blog',
    es: 'blogs',
    fr: 'blogs',
    it: 'blog',
    de: 'blogs',
    pt: 'blog',
    zh: 'blog',
  },
  'pricing': {
    en: 'pricing',
    es: 'precios',
    fr: 'tarifs',
    it: 'prezzi',
    de: 'preise',
    pt: 'precos',
    zh: 'ding-jia',
  },
  'mlm-calculator': {
    en: 'mlm-calculator',
    es: 'calculadora-mlm',
    fr: 'calculateur-mlm',
    it: 'calcolatore-mlm',
    de: 'mlm-rechner',
    pt: 'calculadora-mlm',
    zh: 'mlm-ji-suan-qi',
  },
  'top-5-mlm-software-platforms-in-usa': {
    en: 'top-5-mlm-software-platforms-in-usa',
    it: 'e-migliori-piattaforme-software-da-5-mlm-negli-stati-uniti-2025',
  },
  'network-marketing-software': {
    en: 'network-marketing-software',
    es: 'network-marketing-software',
    fr: 'network-marketing-software',
    it: 'network-marketing-software',
    de: 'network-marketing-software',
    pt: 'network-marketing-software',
    zh: 'network-marketing-software',
  },
  'mlm-companies': {
    en: 'mlm-companies',
    es: 'mlm-companies',
    fr: 'mlm-companies',
    it: 'mlm-companies',
    de: 'mlm-companies',
    pt: 'mlm-companies',
    zh: 'mlm-companies',
  },
};

/**
 * Get page identifier from locale-specific slug
 */
export function getPageFromSlug(slug: string, locale: string): string | null {
  return pageSlugMap[locale]?.[slug] || null;
}

/**
 * Get locale-specific slug from page identifier
 */
export function getSlugFromPage(page: string, locale: string): string | null {
  return pageToSlugMap[page]?.[locale] || null;
}

